import { CaseResultView } from '../../../../features/Results/CaseResultView/CaseResultView';
import { NoResults } from '../../../../features/Results/NoResults/NoResults';
import { useFetchObjectResults } from '../../../../hooks/useFetchChannelResults';
import { CenteredLoader } from '../../../../components/CenteredLoader/CenteredLoader';

export const ObjectResult = () => {
  const { data, isLoading } = useFetchObjectResults();

  if (isLoading) return <CenteredLoader />;

  return (
    <>
      {data !== undefined && data.length > 0 ? (
        <CaseResultView channelResultList={data} type="Object" />
      ) : (
        <NoResults />
      )}
    </>
  );
};
